const dataExample = {
  identifier: { id: 0, name: 'id' },
  address: 1,
  data: [
    ['id', 'address'],
    ['1', 'Rua Botucaraí, 1840 - Bairro Centro - Candelária, RS/96930-000'],
    [
      '2',
      'Rua Santo Antônio, 75 - Bairro Operario - Lagoa Vermelha, RS/95300-000',
    ],
    ['3', 'Cerro do Louro, SN - Bairro iIterior - Formigueiro, RS/97.210-000'],
    [
      '4',
      'Rua Anibal Xavier Bitencourt, 262 - Bairro Pinheiro - Caçapava do Sul, RS/96570-000',
    ],
    [
      '5',
      'Rua Helmott Klain, 41 - Bairro Planalto - Morro Reuter, RS/93990-000',
    ],
    ['6', 'Rua São Roque 431 - Bairro Moinhos - Estrela, RS/95880-000'],
    ['7', 'Rua José Montaury 963 - Bairro Centro - Veranópolis, RS/95330-000'],
    [
      '8',
      'Avenida São João, 792 - Bairro Centro - São João do Polêsine, RS/97230-000',
    ],
    ['9', 'Rua Constantino, SN - Bairro Interior - Progresso, RS/95925-000'],
    ['10', 'Rua feliz, 58 - Bairro Industrial - Farroupilha, RS/95180-000'],
    [
      '11',
      'Rua Francisco Borges Vieira, 33 - Bairro Santa Teresinha - Vacaria, RS/95200-000',
    ],
    [
      '12',
      'Rua Quarenta e sete, SN - Bairro Jardim Algarve - Alvorada, RS/94858-670',
    ],
    ['13', 'BR 116, 410 - Bairro Picada - Eldorado do Sul, RS/92990-000'],
    [
      '14',
      'Rua Paulo de Castro, 830 - Bairro Alesgut - Teutônia, RS/95890-000',
    ],
    [
      '15',
      'Rua Corredor do João, 53 - Bairro Faxinal - Santa Cruz do Sul, RS/96840-540',
    ],
    [
      '16',
      'Av Independência, 361 - Bairro Independência - Machadinho, RS/99880-000',
    ],
    [
      '17',
      'Rua Paulino Azurenha, 759 - Bairro Partenon - Porto Alegre, RS/90680-240',
    ],
    ['18', 'Rua General Neto, 228 - Bairro Centro - Bagé, RS/96400-380'],
    [
      '19',
      'Rua Soldado Enites da Silva Rodrigues, 111 - Bairro Vila Militar - Rio Grande - 96201-270',
    ],
    ['20', 'Linha Barra do Araca, 0 - São Luís Gonzaga,RS/ 97800000'],
    [
      '21',
      'Rua Justino Martins, 70 - Bairro Mário Quintana - Porto Alegre, RS/ 91260330',
    ],
    ['22', 'Rua São Roque 431 - Bairro Moinhos - Estrela, RS/95880-000'],
    [
      '23',
      'Av. Wenceslau Escobar, 1086, ap 217 - Bairro Cristal - Porto Alegre, RS - 91900000',
    ],
    [
      '24',
      'Rua Érico Guilherme Sauler, 667 - Bairro Novo Paraíso - Estrela, RS - 95880-000',
    ],
    [
      '25',
      'Rua Juscelino Kubitschek de Oliveira, 705 - Bairro Parque Branja Esperança - Cachoeirinha, RS - 94960-370',
    ],
    [
      '26',
      'rua Alberto Pasqualini, 589 - bairro Marrocos - Gravataí - 94045-190',
    ],
    [
      '27',
      'Av. Professora Paula Soares, 213 - bairro Jardim Itu Sabará - Porto Alegre - 91220-450',
    ],
    ['28', 'R DOS IPES B: QUATRO LAGOS,521- ARROIO DO SAL'],
    ['29', 'R DOS IPES B: QUATRO LAGOS,521- ARROIO DO SAL'],
    [
      '30',
      'rua Virgílio Lorenzi, 844 - bairro Lorenzi - Santa Maria - 97070-705',
    ],
    ['31', 'RUA ERNESTO SANTOS VIVIAN,268-TRÊS PASSOS/RS, 98600000'],
    ['32', 'RUA ANTÔNIO MARIANTE ,61,CENTRO,ELDORADO DO SUL,RS/92900000'],
    [
      '33',
      'rua Jornalista Arquimedes Fortini, 580 - bairro Maria de Fátima - Rio Grande/96200-000',
    ],
    [
      '34',
      'rua Analdelino R. de Souza - bairro Fenamate - Coronel Bicaco - 98580-000',
    ],
    ['35', 'RUA Caetano gonçalves, 1323 - Centro - Bagé/96400-040'],
    [
      '36',
      'rua Desalmo Pedro Klein - bairro Lajeadinho - São Sebastião do Caí',
    ],
  ],
};

export default dataExample;
